import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    filter: {
      background: theme.palette.background.default,
      borderRadius: '4px',
      padding: '8px 16px 8px 16px',
      marginBottom: '2rem',
      position: 'relative',
      gridColumn: '2',
    },
    grid: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    filterInputs: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '16px',
    },
    label: {
      fontWeight: 600,
      whiteSpace: 'nowrap',
      fontSize: '12px',
      display: 'inline-flex',
      alignItems: 'center',
      color: '#727970',
    },
    select: {
      height: '20px',
      fontSize: '12px',
    },
  }),
)
